<template>
  <v-card :flat="isSmall" class="com-mb-card">
    <v-col
      class="com-mb-card-contents pa-0"
      :class="isSmall ? 'com-mb-card-contents-none-border' : ''"
    >
      <v-row v-if="isAttention" class="ma-0 pa-2">
        <span class="pre-form">{{ text.zoomMapMessage }}</span>
      </v-row>
      <v-row
        v-if="
          !isAttention &&
            (inundations.inundations == null ||
              Object.keys(this.$store.state.inundation.inundations).length == 0)
        "
        class="ma-0 pa-2"
      >
        <span>{{ text.notFoundRvMessage }}</span>
      </v-row>
      <v-row
        v-if="
          !isAttention &&
            inundations.inundations != null &&
            Object.keys(this.$store.state.inundation.inundations).length != 0
        "
        class="ma-0 pa-2"
      >
        <v-select
          v-model="selectedInundation"
          dense
          :items="inundations.inundations"
          :label="text.label"
          item-text="inundationNm"
          item-value="inundationId"
          @change="changeInundation"
          return-object
          hide-details
          class="rvr-nm"
        ></v-select>
      </v-row>
      <v-row class="ma-0 pl-2">
        <span>
          <a
            class="link fld-inulist"
            :href="inuListUrl"
            @click="clickInuListLink"
            >{{ text.inuList }}</a
          ></span
        >
      </v-row>
    </v-col>
  </v-card>
</template>
<script>
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "iu-select",
  props: {
    isSmall: { default: false, type: Boolean },
  },
  data() {
    return {
      selectedInundation: {},
      /** 文字列リソース */
      text: {
        label: "河川を選択",
        zoomMapMessage: "浸水想定を表示できません。\n地図を拡大してください。",
        notFoundRvMessage: "表示できる浸水想定が見つかりませんでした",
        inuList: "このサイトで提供している浸水想定区域図の一覧",
      },
    };
  },
  mounted() {
    if (!this.isAttention) {
      // 選択中浸水想定区域データがストアに設定済みであればプルダウンを更新
      if (
        this.$store.state.inundation.selectedInundationParam &&
        this.$store.state.inundation.selectedInundationParam.inundationId
      ) {
        this.selectedInundation = this.$store.state.inundation.selectedInundationParam;
      }
    }
    // 浸水想定区域未選択状態のみアクセスログ出力
    // 画面遷移時に選択状態であれば地図側でログ出力される
    if (
      this.isAttention ||
      this.inundations.inundations == null ||
      Object.keys(this.$store.state.inundation.inundations).length == 0
    ) {
      PageLog.log({
        page_log: "inundation",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        inun_cd: "-",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    }
  },
  computed: {
    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam,
        };
      },
    },
    /** 注意喚起表示 */
    isAttention: {
      get() {
        return (
          this.$store.state.map.zoom <
          this.$store.state.map.mapConfig.zoomInundation
        );
      },
    },
    /** 提供中の浸水想定一覧URL */
    inuListUrl: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls.inuListLink;
      },
    },
  },
  watch: {
    inundations(val) {
      this.selectedInundation = val.selectedInundationParam;
    },
  },
  methods: {
    changeInundation() {
      setTimeout(() => {
        this.$store.commit(
          "inundation/setSelectedInundationParam",
          this.selectedInundation
        );
      }, 100);
    },
    /** 詳細な浸水想定情報クリック */
    clickInuListLink() {
      // アクセスログ出力
      PageLog.log({
        page_log: "inun_Listlink",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rvr-nm {
  font-size: 0.9rem;
}

.pre-form {
  white-space: pre;
}

.fld-inulist {
  text-decoration: none;
}
</style>
